export default __webpack_public_path__ + "static/QIT_CSL_badge_2024-3f2a1abdab242bcdad89efefe5286c2a.jpg";